import { FhirSections } from ".";
import { AllergyContent } from "./allergies/sidepanel-content";
import { allergyTableData } from "./allergies/table-data";
import { ConditionContent } from "./conditions/sidepanel-content";
import { conditionTableData } from "./conditions/table-data";
import { CoverageContent } from "./coverages/sidepanel-content";
import { coverageTableData } from "./coverages/table-data";
import { EncounterContent } from "./encounters/sidepanel-content";
import { encounterTableData } from "./encounters/table-data";
import { FamilyMemberHistoryContent } from "./family-member-histories/sidepanel-content";
import { familyMemberHistoryTableData } from "./family-member-histories/table-data";
import { ImmunizationContent } from "./immunizations/sidepanel-content";
import { immunizationTableData } from "./immunizations/table-data";
import { LabContent } from "./labs/sidepanel-content";
import { labTableData } from "./labs/table-data";
import { MedicationContent } from "./medications/sidepanel-content";
import { medicationTableData } from "./medications/table-data";
import { ObservationContent } from "./observations/sidepanel-content";
import { observationTableData } from "./observations/table-data";
import { ProcedureContent } from "./procedures/sidepanel-content";
import { procedureTableData } from "./procedures/table-data";
import { RelatedPersonContent } from "./related-persons/sidepanel-content";
import { relatedPersonTableData } from "./related-persons/table-data";
import { ReportContent } from "./reports/sidepanel-content";
import { reportTableData } from "./reports/table-data";
import { SocialHistoryContent } from "./social-history/sidepanel-content";
import { socialHistoryTableData } from "./social-history/table-data";
import { VitalContent } from "./vitals/sidepanel-content";
import { vitalTableData } from "./vitals/table-data";

import AllergySection from "./allergies/fhir-section";
import ConditionsSection from "./conditions/fhir-section";
import CoverageSection from "./coverages/fhir-section";
import EncountersSection from "./encounters/fhir-section";
import FamilyMemberHistorySection from "./family-member-histories/fhir-section";
import ImmunizationsSection from "./immunizations/fhir-section";
import LabsSection from "./labs/fhir-section";
import MedicationsSection from "./medications/fhir-section";
import ObservationsSection from "./observations/fhir-section";
import ProceduresSection from "./procedures/fhir-section";
import RelatedPersonsSection from "./related-persons/fhir-section";
import ReportsSection from "./reports/fhir-section";
import SocialHistorySection from "./social-history/fhir-section";
import VitalsSection from "./vitals/fhir-section";
import { buildDocumentTableData } from "./documents/table-data";

export const fhirSections: FhirSections = [
  {
    title: "Notes",
    key: "reports",
    component: ReportsSection,
    generateTableData: reportTableData,
    sidePanelContent: ReportContent,
  },
  {
    title: "Conditions",
    key: "conditions",
    generateTableData: conditionTableData,
    component: ConditionsSection,
    sidePanelContent: ConditionContent,
  },
  {
    title: "Medications",
    key: "medications",
    component: MedicationsSection,
    generateTableData: medicationTableData,
    sidePanelContent: MedicationContent,
  },
  {
    title: "Allergies",
    key: "allergies",
    component: AllergySection,
    generateTableData: allergyTableData,
    sidePanelContent: AllergyContent,
  },
  {
    title: "Procedures",
    key: "procedures",
    component: ProceduresSection,
    generateTableData: procedureTableData,
    sidePanelContent: ProcedureContent,
  },
  {
    title: "Social History",
    key: "social-history",
    component: SocialHistorySection,
    generateTableData: socialHistoryTableData,
    sidePanelContent: SocialHistoryContent,
  },
  {
    title: "Vitals",
    key: "vitals",
    component: VitalsSection,
    generateTableData: vitalTableData,
    sidePanelContent: VitalContent,
  },
  {
    title: "Labs",
    key: "labs",
    component: LabsSection,
    generateTableData: labTableData,
    sidePanelContent: LabContent,
  },
  {
    title: "Observations",
    key: "observations",
    component: ObservationsSection,
    generateTableData: observationTableData,
    sidePanelContent: ObservationContent,
  },
  {
    title: "Immunizations",
    key: "immunizations",
    component: ImmunizationsSection,
    generateTableData: immunizationTableData,
    sidePanelContent: ImmunizationContent,
  },
  {
    title: "Family Member History",
    key: "family-member-history",
    component: FamilyMemberHistorySection,
    generateTableData: familyMemberHistoryTableData,
    sidePanelContent: FamilyMemberHistoryContent,
  },
  {
    title: "Related Persons",
    key: "related-persons",
    component: RelatedPersonsSection,
    generateTableData: relatedPersonTableData,
    sidePanelContent: RelatedPersonContent,
  },
  {
    title: "Coverage",
    key: "coverages",
    component: CoverageSection,
    generateTableData: coverageTableData,
    sidePanelContent: CoverageContent,
  },
  {
    title: "Encounters",
    key: "encounters",
    component: EncountersSection,
    generateTableData: encounterTableData,
    sidePanelContent: EncounterContent,
  },
  {
    title: "Raw Documents",
    key: "documents",
    generateTableData: buildDocumentTableData,
  },
];
